export var iBinderHeaderEnum;
(function (iBinderHeaderEnum) {
    iBinderHeaderEnum["TENANTID"] = "x-ibinder-tenantid";
    iBinderHeaderEnum["CONTEXT"] = "x-ibinder-context";
    iBinderHeaderEnum["IMPERSONATE"] = "x-ibinder-impersonate";
    iBinderHeaderEnum["PERMISSIONS"] = "x-ibinder-permissions";
})(iBinderHeaderEnum || (iBinderHeaderEnum = {}));
//# sourceMappingURL=iBinderHeaderEnums.js.map